// extracted by mini-css-extract-plugin
export var accountMenuDropdown = "style-module--accountMenuDropdown--b2e79";
export var accountMenuItem = "style-module--accountMenuItem--e6d69";
export var accountMenuItemBlueRing = "style-module--accountMenuItemBlueRing--bab32";
export var accountMenuItemDashboard = "style-module--accountMenuItemDashboard--0d4ed";
export var accountMenuItemDashboardLabel = "style-module--accountMenuItemDashboardLabel--4a8a8";
export var accountMenuItemWithNavIcon = "style-module--accountMenuItemWithNavIcon--2c1d1";
export var accountMenuWrap = "style-module--accountMenuWrap--93498";
export var accountSwitcher = "style-module--accountSwitcher--c7e42";
export var accountSwitcherLabel = "style-module--accountSwitcherLabel--02716";
export var accountSwitcherLogo = "style-module--accountSwitcherLogo--60cf4";
export var accountSwitcherMain = "style-module--accountSwitcherMain--2f8a6";
export var chevron = "style-module--chevron--ce64d";
export var chevronOpen = "style-module--chevronOpen--a6a03";
export var messageBadge = "style-module--messageBadge--936fe";
export var messageBody = "style-module--messageBody--34f05";
export var messageContent = "style-module--messageContent--c81a5";
export var messageList = "style-module--messageList--a48e1";
export var messageListingName = "style-module--messageListingName--54d8e";
export var messageListingTitle = "style-module--messageListingTitle--fd546";
export var messagePreview = "style-module--messagePreview--0a1ba";
export var messageStatus = "style-module--messageStatus--dc50b";
export var messageTab = "style-module--messageTab--40f25";
export var messagesLabel = "style-module--messagesLabel--9d773";
export var navIcon = "style-module--navIcon--31bd8";
export var navIconDashboard = "style-module--navIconDashboard--efdcc";
export var newMessage = "style-module--newMessage--fc07b";
export var pageLink = "style-module--pageLink--f086f";
export var pageLinkDashboard = "style-module--pageLinkDashboard--9d2b4";
export var pageLinkDashboardActive = "style-module--pageLinkDashboardActive--4ab9d";
export var pageList = "style-module--pageList--fe501";
export var pageListDashboard = "style-module--pageListDashboard--ace0f";
export var pageListDashboardChatFade = "style-module--pageListDashboardChatFade--10dd7";
export var read = "style-module--read--6ac7e";
export var sidebar = "style-module--sidebar--cdebc";
export var sidebarChannelList = "style-module--sidebarChannelList--69041";
export var sidebarChannelListBottomFade = "style-module--sidebarChannelListBottomFade--cb268";
export var sidebarChannelListHidden = "style-module--sidebarChannelListHidden--ce249";
export var sidebarChatNavFadeIn = "style-module--sidebarChatNavFadeIn--3ef72";
export var sidebarDashboard = "style-module--sidebarDashboard--a0f1a";
export var unread = "style-module--unread--301c6";